
function useGetSpaceInfo(projectID, spaceID, spaceKey, logoKey, previewKey, handleSuccess) {

    ///console.log("Get file: " + spaceKey);
    try {
        fetch(spaceKey).then(response => {

            if (response.ok) {
                ///console.log("Response OK....");
                response.json().then
                    (
                        (info) => {
                            const { spaceInformation, buttonColors } = info.appearance;
                            const spaceName = spaceInformation.name;
                            const spaceNotSetup = spaceInformation.spaceNotYetSetup;
                            ///console.log("spaceNotSetup :" + spaceNotSetup);
                            const navigationColor = buttonColors.navigationColor;
                            const highlightColor = buttonColors.highlightColor;

                            ///console.log("Space Name : " + spaceName);
                            ///console.log("Navigation Color : " + navigationColor);
                            ///console.log("Highlight Color : " + highlightColor);

                            handleSuccess(
                                spaceNotSetup,
                                logoKey,
                                previewKey,
                                spaceName,
                                navigationColor,
                                highlightColor);
                        })
            }
            else {
                const nullError = "Null";
                //setIncorrectLogin(false);
                handleSuccess(
                    false,
                    projectID,
                    spaceID,
                    nullError,
                    nullError,
                    nullError);
            }
        }

        )
    } catch (error) {
        console.error('Error fetching blob data:', error);
    }

}

export default useGetSpaceInfo;
